<div *transloco="let t; read:'permit'" class="root">
    <ng-container *ngIf="fixedQuestion">
        <div *ngIf="fixedQuestion.translations as questionTranslations" class="root__question-text" [innerHTML]="questionTranslations | haTranslate"></div>
        <pmt-safety-rule class="root__safety-rule-anchor" [safetyRules]="fixedQuestion.safetyRules">
        </pmt-safety-rule>

        <div *ngIf="fixedQuestion.customerComment" class="root__comment">
            <p *ngIf="companyName$ | async as name"><em>{{ name }}</em></p>

            <ng-container *ngIf="getCommentTranslation(fixedQuestion.customerComment.translations) as translatedComment; else fixedCommentTranslationUnavailable">
                <p>{{ translatedComment }}</p>
            </ng-container>

            <ng-template #fixedCommentTranslationUnavailable>
                <p><em>{{ missingCommentTranslationText }}</em></p>
            </ng-template>
        </div>

        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.YesNo">
            <div class="root__choices">
                <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.Yes"
                    (click)="select(CustomerQuestionAnswer.Yes)">
                    {{ t("yes") }}
                </div>
                <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.No"
                    (click)="select(CustomerQuestionAnswer.No)">
                    {{ t("no") }}
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.YesNoNotApplicable">
            <div class="root__choices">
                <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.Yes"
                    (click)="select(CustomerQuestionAnswer.Yes)">
                    {{ t("yes") }}
                </div>
                <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.No"
                    (click)="select(CustomerQuestionAnswer.No)">
                    {{ t("no") }}
                </div>
                <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.NotApplicable"
                    (click)="select(CustomerQuestionAnswer.NotApplicable)">
                    {{ t("notApplicable") }}
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.YesNoWithCondition">
            <div class="root__choices__column">
                <div class="root__choices">
                    <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.Yes"
                        (click)="select(CustomerQuestionAnswer.Yes)">
                        {{ t("yes") }}
                    </div>
                    <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.No"
                        (click)="select(CustomerQuestionAnswer.No)">
                        {{ t("no") }}
                    </div>
                    <div *ngIf="!showConditionOnYes" class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.Condition"
                        (click)="select(CustomerQuestionAnswer.Condition)">
                        {{ t("conditional") }}
                    </div>
                </div>
                <form
                    *ngIf="shouldShowConditionInput && form?.get('condition')"
                    [formGroup]="form">
                    <ha-input formControlName="condition" type="text" class="root__choices__input" [readOnlyOnDisabled]="true" [label]="fixedQuestion.answerTypeConfiguration?.placeholder | haTranslate" />
                </form>
            </div>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.Text">
            <form *ngIf="form?.get('textNumber')" [formGroup]="form">
                <ha-input formControlName="textNumber" type="text" class="root__choices__input" [maxlength]="fixedQuestion.answerTypeConfiguration?.maxLength" [readOnlyOnDisabled]="true" [label]="fixedQuestion.answerTypeConfiguration?.placeholder | haTranslate" />
            </form>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.Number">
            <form *ngIf="form?.get('textNumber')" [formGroup]="form">
                <ha-input formControlName="textNumber" type="number" [min]="fixedQuestion.answerTypeConfiguration?.minValue" [max]="fixedQuestion.answerTypeConfiguration?.maxValue" class="root__choices__input" [readOnlyOnDisabled]="true" [label]="fixedQuestion.answerTypeConfiguration?.placeholder | haTranslate" />
            </form>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.DateTime">
            <form *ngIf="form?.get('dateTime')" [formGroup]="form">
                <div class="root__choices">
                    <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.Now"
                        (click)="select(CustomerQuestionAnswer.Now)">
                        {{ t("now") }}
                    </div>
                    <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.SpecificTime"
                        (click)="select(CustomerQuestionAnswer.SpecificTime)">
                        {{ t("specificTime") }}
                    </div>
                </div>
                <input formControlName="dateTime" type="hidden" class="root__choices__input">
                <ng-container *ngIf="currentCustomerAnswer === CustomerQuestionAnswer.SpecificTime">
                    <div class="root__choices__date" [innerHTML]="t('gasfreeCert.measurementPerformedAt', { date: validDateTime | haDate: 'dateTimeStandard' })"></div>
                    <button type="button" class="root__choices__update-time" (click)="showUpdateTimeModal()">{{ t("validTime.change") }}</button>
                </ng-container>
            </form>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.SubstanceSelection">
            <div class="root__substance-selection">
                <div class="root__substance-selection__instruction">{{ t("gasfreeCert.selectSubstancesInstruction") }}</div>
                    <div *ngIf="loadingFlammableMaterials" class="root__substance-selection__loading">
                        <div class="root__substance-selection__loading__icon"></div>
                        <div class="root__substance-selection__loading__text">{{ t("gasfreeCert.loadingMaterials") }}</div>
                    </div>
                    <form *ngIf="!loadingFlammableMaterials && form" [formGroup]="form">
                        <div class="root__substance-selection__list">
                            <div *ngFor="let material of flammableMaterials" class="root__substance-selection__item">
                                <ha-checkbox
                                    [formControlName]="'material-' + material.flammableMaterialId"
                                    [label]="material.name"
                                />
                            </div>
                        </div>
                    </form>
                <div *ngIf="!loadingFlammableMaterials && ((customerPermitTemplate$ | async)?.allowNewMaterialsBySuperintendent || requiresManualFlammableMaterialAddition)" class="root__substance-selection__add" (click)="openAddNewFlammableMaterialDialog()">
                    <div class="root__substance-selection__add__icon"></div>
                    <div class="root__substance-selection__add__text">{{ t("gasfreeCert.addNew") }}</div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.OptionSelection">
            <div class="root__button-group">
                <div *ngFor="let option of questionOptions" class="root__button-group__confirm">
                    <div
                        class="root__button-group__confirm__button"
                        (click)="toggleQuestionOption(option.id)"
                        [class.root__button-group__confirm__button--active]="isQuestionOptionSelected(option.id)">
                        {{ option.translations | haTranslate }}
                    </div>
                </div>
            </div>

            <form *ngIf="showOptionSelectionFreeTextInput" [formGroup]="form">
                <ha-input
                    class="root__input"
                    formControlName="optionSelectionFreeText"
                    [readOnlyOnDisabled]="true"
                    [label]="fixedQuestion.answerTypeConfiguration?.placeholder | haTranslate">
                </ha-input>
            </form>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.SafetyEquipmentSelection">
            <div class="root__button-group">
                <div *ngFor="let option of sortedSafetyEquipmentOptions" class="root__button-group__confirm">
                    <div class="root__button-group__confirm__button"
                         (click)="toggleSafetyEquipmentOption(option.id)"
                         [class.root__button-group__confirm__button--active]="isSafetyEquipmentOptionSelected(option.id)">
                        {{ option.translations | haTranslate }}
                    </div>
                </div>

                <div class="root__button-group__confirm">
                    <div class="root__button-group__confirm__button"
                         (click)="toggleCustomSafetyEquipment()"
                         [class.root__button-group__confirm__button--active]="customSafetyEquipmentSelected">
                        {{ t("safetyEquipment.other") }}
                    </div>
                </div>
            </div>

            <form *ngIf="customSafetyEquipmentSelected" [formGroup]="form">
                <ha-input class="root__input" formControlName="safetyEquipmentCustomText" [label]="t('safetyEquipment.other')"></ha-input>
            </form>
        </ng-container>
        <ng-container *ngIf="fixedQuestion.answerType === QuestionAnswerType.SubstanceMeasurement">
            <pmt-substance-measurement
                [materials]="materialsWithMeasurements"
                [savedMeasurements]="fixedQuestion.currentFlammableMaterialMeasurements"
                (measurementsChange)="onMeasurementsChange($event)"
                (validChange)="onMeasurementsValidChange($event)"
            ></pmt-substance-measurement>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="customerQuestion">
        <div *ngIf="customerQuestion?.translations as checkpointTranslations" class="root__question-text" [innerHTML]="checkpointTranslations | haTranslate">
        </div>

        <div *ngIf="customerQuestion.comment" class="root__comment">
            <p *ngIf="companyName$ | async as name"><em>{{ name }}</em></p>

            <ng-container *ngIf="getCommentTranslation(customerQuestion.comment) as translatedComment; else customerCommentTranslationUnavailable">
                <p>{{ translatedComment }}</p>
            </ng-container>

            <ng-template #customerCommentTranslationUnavailable>
                <p><em>{{ missingCommentTranslationText }}</em></p>
            </ng-template>
        </div>

        <pmt-safety-rule class="root__safety-rule-anchor" [safetyRules]="customerQuestion.safetyRules"></pmt-safety-rule>

        <div class="root__choices" *transloco="let t; read:'permit.choices'">
            <ng-container *ngFor="let choice of getCheckpointAlternativeNumbers(customerQuestion.alternatives)">
                <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === choice" (click)="select(choice)">
                    {{ t(choice.toString()) }}
                </div>
            </ng-container>
        </div>
    </ng-container>

    <pmt-permit-confirm-dialog class="root__alert" *ngIf="showConfirmDialog" [alert]="fixedQuestion?.alert" [(confirmed)]="alertConfirmed">
    </pmt-permit-confirm-dialog>

    <div *ngIf="showInlineFlammableAtexActions" class="root__inline-actions">
        <button
            *ngIf="showCreateFlammableAtexPermitButton"
            class="root__inline-actions__button"
            type="button"
            (click)="createFlammableAtexPermit()"
            [disabled]="!canProceed"
            [class.root__inline-actions__button--disabled]="!canProceed">
            {{ t("createFlammableAtexPermitFromQuestion") }}
        </button>
        <button
            *ngIf="showRetrieveFlammableAtexPermitButton"
            class="root__inline-actions__button"
            type="button"
            (click)="retrieveFlammableAtexPermit()"
            [disabled]="!canProceed"
            [class.root__inline-actions__button--disabled]="!canProceed">
            {{ t("retrieveFlammableAtexPermitFromQuestion") }}
        </button>
        <button
            *ngIf="showRequestFlammableAtexPermitButton"
            class="root__inline-actions__button"
            type="button"
            (click)="requestFlammableAtexPermit()"
            [disabled]="!canProceed"
            [class.root__inline-actions__button--disabled]="!canProceed">
            {{ t("requestFlammableAtexPermitFromQuestion") }}
        </button>
    </div>

    <div class="root__actions">
        <button class="root__actions__back" type="button" (click)="goBack()">{{ t("back") }}</button>
        <button
            class="root__actions__continue"
            type="button"
            [disabled]="disableDefaultContinueButton"
            (click)="continue()"
            [class.root__actions__continue--disabled]="disableDefaultContinueButton">
            {{ t("next") }}
        </button>
    </div>
</div>
